module.exports = __webpack_public_path__ + "media/secondSection/pink-circle-244ea268.png";